/* true, wenn das Gerät mit Maus/Trackpad bedient wird (kein Touch) */
export const hasFinePointer = () => {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return true;
  }

  return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
};
